import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import { getUser, getUser_v2 } from '../utils/dropdownlist'
import { MdDone, MdWarning, MdModeEdit } from 'react-icons/md'
import { FaEdit } from 'react-icons/fa'
import { IconContext } from 'react-icons/lib'
import { CSVLink } from 'react-csv'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import Select from 'react-select'

const headers = [
  {
    label: 'Supplier',
    key: 'supplier_name',
  },
  {
    label: 'Category',
    key: 'category',
  },
  {
    label: 'Product No.',
    key: 'product_no',
  },
  {
    label: 'Name',
    key: 'name',
  },
  {
    label: 'Quantity',
    key: 'sqty',
  },
  {
    label: 'Sales',
    key: 'sales',
  },
]

class SalesReport extends React.Component {
  _isMounted = true
  salesDetail = StorageService.getSession('SalesReport')
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
      isLoading: true,
      store_id: this.salesDetail && this.salesDetail.store_id ? this.salesDetail.store_id : this.props.data.storeList[0].store_id,
      storeList: this.props.data.storeList,
      date: this.salesDetail && this.salesDetail.date ? this.salesDetail.date : moment().subtract(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      // fm_date:
      //   this.salesDetail && this.salesDetail.fm_date
      //     ? this.salesDetail.fm_date
      //     : moment()
      //         .subtract(1, 'days')
      //         .tz('Asia/Singapore')
      //         .format('YYYY-MM-DD'),
      // to_date:
      //   this.salesDetail && this.salesDetail.to_date
      //     ? this.salesDetail.to_date
      //     : moment()
      //         .subtract(1, 'days')
      //         .tz('Asia/Singapore')
      //         .format('YYYY-MM-DD'),
      fm_date: this.salesDetail && this.salesDetail.fm_date ? this.salesDetail.fm_date : moment().startOf('month').format('YYYY-MM-DD'),
      to_date: this.salesDetail && this.salesDetail.to_date ? this.salesDetail.to_date : moment().endOf('month').format('YYYY-MM-DD'),
      reportList: [],
      sort_supplier: this.salesDetail && this.salesDetail.sort_supplier ? this.salesDetail.sort_supplier : 0,
    }
  }

  componentDidMount() {
    if (this.salesDetail) {
      this.getReport()
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.salesDetail ? this.salesDetail : {}
    data[name] = value
    StorageService.setSession('SalesReport', data)
    this.salesDetail = StorageService.getSession('SalesReport')
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
    let data = this.salesDetail ? this.salesDetail : {}
    data[name] = value
    StorageService.setSession('SalesReport', data)
    this.salesDetail = StorageService.getSession('SalesReport')
  }

  storeHandler = e => {
    const { label, value } = e
    this.setState({
      store_id: value,
    })
    let data = this.paymentDetail ? this.paymentDetail : {}
    data['store_id'] = value
    StorageService.setSession('PaymentReport', data)
    this.paymentDetail = StorageService.getSession('PaymentReport')
  }

  CsvNotFound() {
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: 'Data Not Found',
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  getReport() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
      sort_supplier: this.state.sort_supplier ? 1 : 0,
    }

    axios
      .post(url + ':3003/v2/order/report/sales', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({
            reportList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    let options = [
      ...this.state.storeList
        .reduce((r, o) => {
          let key = o.store_id
          let item = { value: o.store_id, label: o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        <Row>
          <Col>
            <h5>Item Sales Report</h5>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Label>Store</Label>
            {/* <Input
              className="ps-input-small"
              type="select"
              name="store_id"
              value={this.state.store_id}
              onChange={this.changeHandler}
            >
              {this.state.storeList.map(item => {
                return (
                  <option key={item.store_id} value={item.store_id}>
                    {item.name}
                  </option>
                );
              })}
            </Input> */}
            <Select options={options} value={options.filter(i => i.value == this.state.store_id)} name="store_id" onChange={this.storeHandler} menuPosition={'fixed'} required />
          </Col>
          <Col md={3}>
            <Label>Order Date</Label>
            <Input className="ps-input-small" type="date" name="fm_date" onChange={this.changeHandler} value={this.state.fm_date} />
          </Col>
          <Col md={1}>
            <Label></Label>
            <p
              style={{
                padding: '0.4rem',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}>
              To
            </p>
          </Col>
          <Col md={3}>
            <Label>Order Date</Label>
            <Input className="ps-input-small" type="date" name="to_date" onChange={this.changeHandler} value={this.state.to_date} />
          </Col>
          <Col md={2} className="ps-margin-auto-desktop">
            <Button className="ps-input-small" onClick={() => this.getReport()}>
              Search
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <FormGroup check>
              <Label check>
                <Input type="checkbox" name="sort_supplier" checked={this.state.sort_supplier} onChange={this.checkHandler} />
                Sort Supplier
              </Label>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <CSVLink
              data={this.state.reportList}
              headers={headers}
              filename={'ItemSalesReport_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'}
              onClick={() => {
                if (this.state.reportList.length < 1) {
                  this.CsvNotFound()
                  return false
                }
              }}>
              <Button type="button" className="ps-input-small theme-button-primary">
                Export
              </Button>
            </CSVLink>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table className="ps-table tb-col-6 ps-responsive-table">
              <Thead>
                <Tr>
                  <Th>Supplier</Th>
                  <Th>Category</Th>
                  <Th>Product No.</Th>
                  <Th>Name</Th>
                  <Th>Quantity</Th>
                  <Th>Sales</Th>
                </Tr>
              </Thead>
              <Tbody>
                {this.state.reportList.length < 1 && (
                  <Tr>
                    <Td colSpan="6">
                      <div className="ps-empty-data">
                        <div className="empty-content">
                          <h4>No data to show</h4>
                        </div>
                      </div>
                    </Td>
                  </Tr>
                )}
                {this.state.reportList.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>{item.supplier_name}</Td>
                      <Td>{item.category}</Td>
                      <Td>{item.product_no}</Td>
                      <Td>{item.name}</Td>
                      <Td>{item.sqty}</Td>
                      <Td>{item.sales}</Td>
                    </Tr>
                  )
                })}
              </Tbody>
            </Table>
          </Col>
        </Row>
      </>
    )
  }
}

export default SalesReport
